/*External dependencies */
import update from 'immutability-helper';

/* Local dependencies */
import { DeleteDeviceActions, DeleteDeviceActionTypes } from './action';

export interface DeleteDeviceState {
  isDeleteDeviceLoading: boolean;
  statusMessage: string;
  error: string;
}

export const initialDeleteDeviceState: DeleteDeviceState = {
  isDeleteDeviceLoading: false,
  statusMessage: '',
  error: '',
};

export function deleteDeviceReducer(state = initialDeleteDeviceState, action: DeleteDeviceActions) {
  switch (action.type) {
    case DeleteDeviceActionTypes.DELETE_DEVICE_REQUEST:
      return update(state, {
        isDeleteDeviceLoading: { $set: true },
      });
    case DeleteDeviceActionTypes.DELETE_DEVICE_SUCCEEDED:
      return update(state, {
        statusMessage: { $set: action.statusMessage },
        isDeleteDeviceLoading: { $set: false },
      });
    case DeleteDeviceActionTypes.DELETE_DEVICE_FAILED:
      return update(state, {
        error: { $set: action.error },
        isDeleteDeviceLoading: { $set: false },
      });
    default:
      return state;
  }
}
